import $ from 'jquery';
import LP from '../0-lp';


//---------------------- //
//Respondents Status      //
//---------------------- //
LP.respondentsStats = {
    isReloading: false,

    init: function () {

    },

    reload: function () {
        if (LP.respondentsStats.isReloading) {
            return;
        }

        var setLoading = function () {
            LP.respondentsStats.isReloading = true;
            $('.lp-stats-loader').timedLoader(1);
        };
        var unsetLoading = function () {
            LP.respondentsStats.isReloading = false;
            $('.lp-stats-loader').timedLoader(false);
        };

        setLoading();

        var url = 'backend/getRespondentsStatus/';
        var param = 'poll=' + $('#pollId').val();
        window.Browser.loadHTML($('#respondentStatus'), url, param, function () {
            unsetLoading();
        }, function () {
            unsetLoading();
        });
    }
};

//---------------------- //
// Respondents List      //
//---------------------- //
LP.respondentsList = {
    isReloading: false,
    shouldReloadAgain: false,

    init: function () {
        $('a[action="exportRespondents"]').click(LP.respondentsList.exportPrivacyWarningPopover);
        $('a[action="exportBlacklist"]').click(LP.respondentsList.exportPrivacyWarningPopover); //Works with both buttons
        $('a[dialog="newRespondent"]').click(function () {
            LP.respondentsList.openEditDialog($(this), false);
            return false;
        });

        LP.dlgRespImport.prepare('a[dialog="importRespondents"]');

        LP.respondentsList.initFilter();
        LP.respondentsList.initList();
    },

    initFilter: function () {
        $('#respondent-ext-toggle').click(function () {
            var content = $('#respondents-ext-search');
            if (content.is(':visible')) {
                content.hide();
            } else {
                content.show();
            }
        });

        $('a[action="clearFilters"]').click(function () {
            LP.respondentsList.clearFilter(true);
        });
        var searchRespondent = $('#lp-search-respondent');
        searchRespondent.keypress(function (e) {
            if (e.which == 13) {
                LP.respondentsList.filterRespondents();
            }
        });
        searchRespondent.blur(function () {
            LP.respondentsList.filterRespondents($(this).val());
        });
        $('a[action="searchRespondent"]').click(function () {
            LP.respondentsList.filterRespondents();
        });

        $('.lp-attr-select').change(LP.respondentsList.filterRespondents);
        $('.lp-attr-filter').click(LP.respondentsList.filterRespondents);
        $('.lp-attr-input').keypress(function (e) {
            if (e.which == 13) {
                LP.respondentsList.filterRespondents();
                return false;
            }
        });
        $('.lp-attr-invite').click(LP.respondentsList.filterRespondents);
        $('.lp-attr-remind').click(LP.respondentsList.filterRespondents);

        $('#lp-respondent-filter-show').click(function () {
            var content = $('#lp-respondent-filter-content');
            if (!content.is(':visible')) {
                window.Browser.send('backend/toggleRespondentFilter/', 'poll=' + $('#pollId').val() + '&enable=1', function () {
                    $('#lp-respondent-filter-content').slideDown();
                });
            } else {
                window.Browser.send('backend/toggleRespondentFilter/', 'poll=' + $('#pollId').val() + '&enable=0', function () {
                    $('#lp-respondent-filter-content').slideUp();
                });
            }
        });

    },

    initList: function () {
        $('.lp-resp-loader').html('');

        $('a[action="sortBy"]').click(LP.respondentsList.onChangeSort);
        $('a[action="pageSelect"]').click(LP.respondentsList.onChangePage);
        $('select[action="changePageSize"]').change(LP.respondentsList.onChangeSize);

        $('a[action="deleteSelectedRespondents"]').click(LP.respondentsList.deleteSelectedRespondents);

        $('a[action="editRespondent"]').click(function () {
            LP.respondentsList.openEditDialog($(this), false);
            return false;
        });
        $('a[action="deleteRespondent"]').click(LP.respondentsList.deleteRespondent);

        LP.dlgMailJob.prepareFromPage('a[action="mailRespondent"]', {
            afterSubmit: function () {
                LP.respondentsList.reload();
            }
        });
        LP.dlgMailJob.prepareFromPage('a[action="mailtoSelectedRespondents"]', {
            afterSubmit: function () {
                LP.respondentsList.reload();
            }
        });

        $('.selectableTD').click(function () {
            var ref = $('label', this).attr('for');
            var input = $('#' + ref);
            var checked = input.is(':checked');
            input.prop('checked', !checked);

            $('#selectShown').prop('checked', false);
            $('#selectAll').prop('checked', false);
            $('#selectFiltered').prop('checked', false);
            var checkItems = $('.lp_resp_select:checked');
            LP.respondentsList.enableSelection(checkItems.length > 0);
            return false;

        });

        var selectFunc = function () {
            var checked = $(this).is(':checked');
            if ($(this).attr('id') != 'selectShown') {
                $('#selectShown').prop('checked', false);
            }
            if ($(this).attr('id') != 'selectAll') {
                $('#selectAll').prop('checked', false);
            }
            if ($(this).attr('id') != 'selectFiltered') {
                $('#selectFiltered').prop('checked', false);
            }
            if (checked) {
                $('.lp_resp_select').prop('checked', true);
            } else {
                $('.lp_resp_select').prop('checked', false);
            }
            LP.respondentsList.enableSelection(checked);
        };

        var selectAll = $('#selectAll');
        var selectFiltered = $('#selectFiltered');
        var selectShown = $('#selectShown');
        selectAll.change(selectFunc);
        selectFiltered.change(selectFunc);
        selectShown.change(selectFunc);

        var selState = $('#selectedState').val();
        if (selState == 'ALL') {
            selectAll.trigger('click');
        } else if (selState == 'FILTER') {
            selectFiltered.trigger('click');
        } else if (selState == 'LIST') {
            selectShown.trigger('click');
        }
        LP.respondentsList.enableSelection(selState != undefined && selState != '');

        $('.lp_resp_select').change(function () {
            $('#selectShown').prop('checked', false);
            $('#selectAll').prop('checked', false);
            $('#selectFiltered').prop('checked', false);
            var checkItems = $('.lp_resp_select:checked');
            LP.respondentsList.enableSelection(checkItems.length > 0);
        });

    },

    openEditDialog: function (anchor, clearFilterAfter) {
        var params = {
            name: 'respondent',
            ajax: anchor.attr('url'),
            request: anchor.attr('url_params'),
            title: anchor.attr('title'),
            sizeable: true,
            width: 650,
            height: 450,
            afterSubmit: function () {
                if (clearFilterAfter) {
                    LP.respondentsList.clearFilter(false);
                }
                LP.respondentsList.reload();
            }
        };

        if (!anchor.is('[disabled]')) {
            LP.Dialog.open(params);
        }
    },

    setSelectionCounter: function () {
        var numItems = LP.respondentsList.getSelectionCounter();

        $('a[action="mailtoSelectedRespondents"] .num').html(numItems);
        $('a[action="deleteSelectedRespondents"] .num').html(numItems);
    },

    getSelectionCounter: function () {
        var checkItems = $('.lp_resp_select:checked');
        var notChecked = $('.lp_resp_select:not(:checked)');
        var numCheckedItems = checkItems.length;
        var numNotChecked = notChecked.length;

        var numSelected;
        if ($('#selectAll').is(':checked')) {
            numSelected = $('#numAll').val() - numNotChecked;
        } else if ($('#selectFiltered').is(':checked')) {
            numSelected = $('#numFiltered').val() - numNotChecked;
        } else {
            numSelected = numCheckedItems;
        }

        return numSelected;
    },

    enableSelection: function (enable) {
        if (enable) {
            $('a[action="mailtoSelectedRespondents"]').removeAttr('disabled');
            $('a[action="deleteSelectedRespondents"]').removeAttr('disabled');
            LP.respondentsList.setSelectionCounter(true);
        } else {
            $('a[action="mailtoSelectedRespondents"]').attr('disabled', '1');
            $('a[action="deleteSelectedRespondents"]').attr('disabled', '1');
            LP.respondentsList.setSelectionCounter(false);
        }
    },

    reload: function (task, options) {
        if (LP.respondentsList.isReloading) {
            LP.respondentsList.shouldReloadAgain = false;
            return;
        }

        LP.respondentsList.isReloading = true;
        LP.respondentsList.shouldReloadAgain = false;

        if (!task) {
            task = 'getRespondentsTable';
        }

        var params = 'poll=' + $('#pollId').val();
        if (options) {
            params += '&' + options;
        }

        if ($('#selectAll').is(':checked')) {
            params += '&select=ALL';
        }
        if ($('#selectFiltered').is(':checked')) {
            params += '&select=FILTER';
        }
        if ($('#selectShown').is(':checked')) {
            params += '&select=LIST';
        } else {
            params += '&select=';
        }

        $('.lp-resp-loader').timedLoader(1);
        window.Browser.loadHTML($('#lp-table-respondents'), 'backend/' + task, params, LP.respondentsList.onReloaded, function () {
            LP.respondentsList.isReloading = false;
            $('.lp-resp-loader').timedLoader(false);
        });

        return true;
    },

    onReloaded: function () {
        LP.respondentsList.isReloading = false;
        $('.lp-resp-loader').html('');
        LP.respondentsList.initList();
        if (LP.respondentsList.shouldReloadAgain) {
            LP.respondentsList.filterRespondents();
        }
    },

    clearFilter: function (reload) {
        LP.respondentsList.isReloading = true;
        $('.lp-attr-select option').removeAttr('selected');
        $('.lp-attr-input').val('');
        $('.lp-attr-invite').prop('checked', false);
        $('.lp-attr-remind').prop('checked', false);
        $('.lp-attr-filter').prop('checked', false);
        $('#lp-search-respondent').val('');
        LP.respondentsList.isReloading = false;
        if (reload) {
            LP.respondentsList.filterRespondents();
        }
    },

    onChangeSize: function () {
        var params = '&size=' + $(this).val();
        LP.respondentsList.reload('getRespondentsTable', params);
    },

    onChangeSort: function () {
        var sortDir = $(this).attr('sortDir');
        if (sortDir == undefined) {
            sortDir = 'ASC';
        }
        var params = '';
        params += '&sortBy=' + $(this).attr('sortBy');
        params += '&sortDir=' + sortDir;
        LP.respondentsList.reload('getRespondentsTable', params);
    },

    onChangePage: function () {
        var params = '&page=' + $(this).attr('page');
        LP.respondentsList.reload('getRespondentsTable', params);
    },

    filterRespondents: function () {
        var params = $('#lp-resp-filter input, #lp-resp-filter select').serialize();
        params = params + '&search=' + $('#lp-search-respondent').val();
        LP.respondentsList.reload('filterRespondents', params);
    },

    deleteRespondent: function () {
        if ($(this).is('[disabled]')) {
            return false;
        }

        $('#successmsg').hide();
        $('#errormsg').hide();

        var anchor = this;
        var url = $(anchor).attr('url');
        var params = $(anchor).attr('url_params');

        var onConfirm = function () {
            window.Browser.send(url, params,
                function (json) {
                    if (json.message) {
                        $('#successmsg').html(json.message).show('fast');
                    }
                    $('#errormsg').hide();

                    LP.respondentsList.reload();

                    return true;
                },
                function (json) {
                    var errorMsg = json.errors.join('<br>');
                    $('#errormsg').html(errorMsg).show('fast');
                    $('#successmsg').hide();
                    return true;
                }
            );
        };

        LP.UI.warnConfirm(anchor, onConfirm);
        return false;
    },

    deleteSelectedRespondents: function () {
        if ($(this).is('[disabled]')) {
            return false;
        }

        var state = LP.respondentsList.findSelectedRespondents();
        var count = LP.respondentsList.getSelectionCounter();
        var poll = $('#pollId').val();

        var task = '',
            data = '',
            confirm;

        switch (state) {
            case 'ALL'    :
                task = 'deleteAllRespondents';
                confirm = $('#confirm_delete_all');
                break;
            case 'FILTER' :
                task = 'deleteFilteredRespondents';
                confirm = $('#confirm_delete_filtered');
                break;
            case 'SELECT' :
                task = 'deleteSelectedRespondents';
                confirm = $('#confirm_delete_selected');
                data = LP.respondentsList.getSelectedRespondents();
                break;
        }

        var confirmTxt = confirm.html().replace(/%NUM%/g, count);

        if (task) {
            var url = 'backend/' + task + '/';
            var params = 'poll=' + poll;
            if (data) {
                params += '&selected=' + data.selected;
            }
            $('#successmsg').hide();
            $('#errormsg').hide();

            var onConfirm = function () {
                $('.lp-resp-loader').timedLoader(1);
                window.Browser.send(url, params,
                    function (json) {
                        if (json.message) {
                            $('#successmsg').html(json.message).show('fast');
                        }
                        $('.lp-resp-loader').timedLoader(false);
                        $('#errormsg').hide();
                        if (state != 'SELECT') {
                            LP.respondentsList.clearFilter();
                        }
                        LP.respondentsList.reload();

                        return true;
                    },
                    function (json) {
                        var errorMsg = json.errors.join('<br>');
                        $('#errormsg').html(errorMsg).show('fast');
                        $('#successmsg').hide();

                        $('.lp-resp-loader').html('');
                        return true;
                    });
            };

            return LP.UI.warnConfirm(confirmTxt, onConfirm);
        }
        return false;
    },

    getSelectedRespondents: function () {
        var list = new Array();
        $('.lp_resp_select:checked').each(function (index, item) {
            list.push($(item).attr('value'));
        });
        return {selected: list};
    },

    findSelectedRespondents: function () {
        var allRespondents = $('#selectAll').is(':checked');
        if (allRespondents) {
            return 'ALL';
        }

        var filteredRespondents = $('#selectFiltered').is(':checked');
        if (filteredRespondents) {
            return 'FILTER';
        }

        return 'SELECT';
    },

    exportPrivacyWarningPopover: function () {
        var anchor = $(this);
        if (!anchor.attr('disabled') == '1') {
            LP.UI.confirm(anchor.attr('confirm'), function () {
                LP.clickLink(anchor);
            });
        }
        return true;
    }

};

//---------------------- //
//Import Job Methods    //
//---------------------- //
LP.respondentsImport = {

    initJob: function () {
        $('#lp-cancel-import').click(LP.respondentsImport.cancelJob);

        LP.initProgressBars($('#lp-import-progressbar'));
        LP.respondentsImport.updateProgressBar();
    },

    cancelJob: function () {
        if ($(this).is('[disabled]')) {
            return false;
        }
        var url = $(this).attr('url');
        var params = $(this).attr('url_params');
        var onConfirm = function () {
            window.Browser.send(url, params);
        };
        return LP.UI.warnConfirm(this, onConfirm);
    },

    updateProgressBar: function () {
        var jobId = $('#jobId').val();
        var $bar = $('#lp-import-progressbar');
        if ($bar.is(':visible')) {
            window.Browser.send('backend/getImportStatus/', 'jobId=' + jobId, function (json) {

                    LP.respondentsImport.updateImportStats(json);

                    if (json.progress < 100) {
                        setTimeout('LP.respondentsImport.updateProgressBar()', 1500);
                    } else {
                        $('.ui-progressbar-value').removeClass('ui-corner-left').addClass('ui-corner-all');
                        LP.respondentsList.reload();
                        $('#lp-cancel-import').hide();
                    }

                    $('#lp-import-resultstable').show();
                },
                function () {
                });
        }
    },

    updateImportStats: function (stats) {
        var $bar = $('#lp-import-progressbar');
        $('.ui-progressbar-value', $bar).css({width: stats.progress + '%'});
        $('#lp-import-progress-text').html(stats.text);
        $('.lp-percent', $bar).html(stats.progress + '%');

        $('#lp-import-job-id').html(stats.jobId);
        $('#lp-import-result-runtime span').html(stats.runtime);
        $('#lp-import-result-entries span').html(stats.entries);
        $('#lp-import-result-imported').html(stats.imported);
        $('#lp-import-result-doubles').html(stats.doubles);
        $('#lp-import-result-failed').html(stats.failed);
    }
};

LP.dlgSendingList = {

    initDialog: function () {
    },

    submit: function (json) {
        window.open(json.link, 'keysemails', '');
    }
};
